<template lang="pug">
  .wrap
    .katintro(v-if="taxonomy")
      h1 {{ taxonomy.name }}
      .kattext
        p {{ $t(`Die Fundushallen enthalten viel mehr, als hier abgebildet, alle Rubriken werden ständig aufgestockt. Daher fragen Sie einfach nach, wenn Sie das Gesuchte nicht finden.`) }}
    .metanav(v-sticky sticky-offset="offset" sticky-side="top")
      .left
        router-link(:to="{ name: 'home' }") {{ $t(`Zurück zur Fundus Übersicht`) }}
        strong(v-if="taxonomy") {{ taxonomy.name }}
      .right
        .filterbox
            div.name Filter
            .filter(:class="{ loading: loading }")
              ul(v-if="taxonomyChildren")
                li
                  strong(v-if="!$route.params.subslug") {{ $t(`Kategorie`) }}
                  strong(v-else) {{ subtaxonomy.name }}
                  ul
                    li
                      router-link(:to="{ name: 'kategorie', params: { slug: $route.params.slug }, query: { color: $route.query.color, anzahl: $route.query.anzahl } }") Alle
                    li(v-for="kategorie in taxonomyChildren")
                      router-link(:to="{ name: 'subkategorie', params: { slug: $route.params.slug, subslug: kategorie.slug }, query: { color: $route.query.color, anzahl: $route.query.anzahl } }") {{ kategorie.name }}                 
              ul
                li
                  strong {{ $t(`Farbe`) }}
                  ul
                    li
                      router-link(:to="{ path: $route.path, query: { anzahl: $route.query.anzahl } }") {{ $t(`Alle`) }}
                    li(v-for="color in filterColors")
                      router-link(:to="{ path: $route.path, query: { color, anzahl: $route.query.anzahl } }") {{ color }}
              ul
                li
                  strong(v-if="!filter.quantity") {{ $t(`Anzahl`) }}
                  strong(v-else) {{ filter.quantity }}
                  ul
                    li
                      router-link(:to="{ path: $route.path, query: { color: $route.query.color } }") {{ $t(`Alle`) }}
                    li(v-for="anzahl in filterQuantities")
                      router-link(:to="{ path: $route.path, query: { color: $route.query.color, anzahl: anzahl.filter } }") {{ anzahl.name }}
              transition(name="fade")
                ul(v-if="$route.query.color || $route.query.anzahl || $route.params.subslug")
                  li
                    router-link(:to="{ name: 'kategorie', params: { slug: $route.params.slug } }") {{ $t(`Zurücksetzen`) }}
      //- .right
      //-   router-link.merklisten(to="/merklisten") {{ $t(`Ihre Merkliste`) }}
    .uebersicht(ref="uebersicht")
      template(v-if="filterList.length > 0")
        transition-group(name="list").grid
          fundus-tile(v-for="fundus in filterList" :fundus="fundus" :key="fundus.id").fundus
      transition(name="fade" mode="out-in")
        #loading(v-if="loading") 
          loading
        h2(v-if="!loading && filterList.length === 0").error {{ $t(`Keine Artikel gefunden`) }} 😞
</template>

<script>
// TODO:
// - filter for subtaxonomies
import Sticky from 'vue-sticky-directive'
import { getFundusList as apiGetFundusList, getTaxonomyList as apiGetTaxonomyList } from '@/api'
import FundusTile from '@/components/FundusTile.vue'
import Loading from '@/components/Loading.vue'
import { metaDefaults } from '@/app.config'
export default {
  name: 'Taxonomie',
  metaInfo () {
    if (typeof(this.taxonomy) != "undefined") {
      return {
        title: `${this.taxonomy.name} bei ${metaDefaults.title}`,
        titleTemplate: null,
        meta: [
          { hid: 'description', name: 'description', content: `${this.taxonomy.name} bei ${metaDefaults.title}` }
        ]
      }
    }
  },
  data: () => ({
    containerMonitor: null,
    fundusList: [],
    filterList: [],
    loading: true,
    filter: {
      color: null,
      quantity: null
    },
    filterColors: [ 
      'wooden', 'brown', 'black', 'white', 'gold', 'red', 'green', 'blue', 'silver', 'beige', 'transparent', 
      'gray', 'yellow', 'orange', 'pink', 'copper', 'colorful', 'chrome', 'purple', 'turquoise',
      'apricot', 'cognac', 'peach', 'pale-green',
    ],
    filterQuantities: [
      { filter: 1, name: '1' },
      { filter: 2, name: '2+' },
      { filter: 10, name: '10+ '},
      { filter: 25, name: '25+' },
      { filter: 50, name: '50+' },
      { filter: 100, name: '100+' }
    ]
  }),
  methods: {
    async filterAsync (array, predicate) {
      const res = [];
      await array.reduce(async (promise, n) => {
          await promise;
          if (await predicate(n)) {
              res.push(n);
          }
      }, Promise.resolve());
      return res;
    },
    async filterFundusList () {

        try {
          this.loading = true
          this.filterList = []
          let color = null
          let slug = this.$route.params.slug
          if (this.$route.params.subslug) { slug = this.$route.params.subslug }
          if (this.filter.color) { color = this.filter.color }
          const fundus = await apiGetTaxonomyList({ slug, quantity: this.filter.quantity, color })   
          this.filterList = fundus.data
          this.loading = false
        } catch (error) {
          this.loading = false
          console.error(error)
        }


    }
  },
  components: {
    FundusTile,
    Loading
  },
  computed: {
    wishlists: {
      get() {
        return this.$store.state.wishlists
      }
    },
    currentList: {
      get() {
        return this.$store.state.currentList
      }
    },
    taxonomy: {
      get() {
        return this.$store.getters.taxonomyBySlug(this.$route.params.slug)
      }
    },
    subtaxonomy: {
      get() {
        return this.$store.getters.taxonomyBySlug(this.$route.params.subslug)
      }
    },
    taxonomyChildren: {
      get() {
        if (!this.taxonomy) return
        return this.$store.getters.taxonomyChildren({ parent: this.taxonomy.id }).map(item => {
          return {
            name: item.name.replace(new RegExp(" / ", 'g'), ", "),
            slug: item.slug
          }
        }).sort()
      }
    }
  },
  watch: {
    '$route': async function (to, from) {
      if (to.name !== "fundus" && from.name !== "fundus") {
        if (typeof(to.query.color) != "undefined") {
          this.filter.color = this.filterColors.filter(filter => filter === to.query.color)[0]
        } else {
          this.filter.color = null
        }
        if (typeof(to.query.anzahl) != "undefined") {
          this.filter.quantity = to.query.anzahl
        } else {
          this.filter.quantity = null
        }
        this.filterFundusList()
      }
    }
  },
  async mounted () {

    window._paq.push(['setCustomUrl', window.location])
    this.loading = true

    this.filter.color = this.filterColors.filter(filter => filter === this.$route.query.color)[0]
    this.filter.quantity = this.$route.query.anzahl
    if (this.filter.color || this.filter.quantity || this.$route.params.subslug) {
      this.filterFundusList()
      return
    }

    try {
      const fundus = await apiGetTaxonomyList({ slug: this.$route.params.slug })
      this.fundusList = fundus.data
      this.filterList = this.fundusList
      this.loading = false
    } catch (error) {
      this.loading = false
      window._paq.push(['trackEvent', 'Error', 'Loading Fundus Listing', window.location])
    }

    window._paq.push(['setDocumentTitle', this.$metaInfo.title])
    window._paq.push(['trackPageView'])
    
  },
  directives: { Sticky }
}
</script>

<style scoped lang="sass">
.list
  position: relative
.list-item
  transition: all .25s
.list-enter, .list-leave-to
  opacity: 0
.list-leave-active
  position: absolute

@media only screen and (min-width: 1025px)
  .katintro h1
    word-spacing: 150px
.grid
  display: grid
  //grid-template-columns: 25% 25% 25% 25%
  grid-template-columns: repeat(4, 1fr)
  grid-gap: 20px
  @media only screen and (max-width: 1000px)
    grid-template-columns: repeat(3, 1fr)
  @media only screen and (max-width: 769px)
    grid-template-columns: repeat(2, 1fr)

.filterbox
  .name
    display: inline-block
.filter
  display: inline-block
  width: auto
  &.loading
    pointer-events: none

.uebersicht .fundus
  margin: 0
  z-index: 1

h2.error
  text-align: center
  line-height: 64px

.metanav.sticky
  position: fixed
  top: 0
  left: 0
  width: 100%
  z-index: 1000
  background: #fff
  border-bottom: 1px solid #333
  padding: 5px

.pagination--bottom
  position: fixed
  bottom: 0
  left: 0
  width: 100%
  border-top: 1px solid #333
  background: #fff
  padding: 10px
  text-align: center
  justify-content: center
  align-content: center
  display: flex
  z-index: 100
  span
    margin: 0 10px
  a
    display: inline-block
    margin: 0 10px
    text-decoration: none
    color: #cc0000
    &.disabled
      opacity: 0
      pointer-events: none

#loading
  width: 100%
  text-align: center

#debugme
  position: fixed
  top: 0
  left: 0
  width: 25%
  height: 25%
  background: #fff
  color: #000
  padding: 10px
  z-index: 1000

.scrollpoints
  position: absolute
  left: 0
  width: 100%
  border-bottom: 10px dashed red
  z-index: 99999

.metanav
  display: flex
  margin-top: -10px
  padding: 10px 0
  transition: all .2s ease
  background: #fff
  z-index: 10
  justify-content: space-between
.top-sticky
    margin-top: 0
</style>